import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { useState } from 'react';
// import './OrderDashboard.css';

const deliveryStatuses = [
    { label: 'Pending', value: 'pending' },
    { label: 'Ready for Pickup', value: 'ready' },
    { label: 'Delivered', value: 'delivered' },
];

const sampleDeliveries = [
    {
        id: 'ORD-001',
        recipient: 'John Doe',
        country: 'USA',
        status: 'ready',
        code: 'QR-001',
        amountDue: 35.5
    },
    {
        id: 'ORD-002',
        recipient: 'Jane Smith',
        country: 'Germany',
        status: 'pending',
        code: 'QR-002',
        amountDue: 88.75
    },
    {
        id: 'ORD-003',
        recipient: 'Takeshi Yamada',
        country: 'Japan',
        status: 'delivered',
        code: 'QR-003',
        amountDue: 0
    },
];

const DeliveryPage = () => {
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [selectedDelivery, setSelectedDelivery] = useState(null);
    const [balancePayment, setBalancePayment] = useState(0);

    const filteredDeliveries = sampleDeliveries.filter(
        (delivery) =>
            (!selectedStatus || delivery.status === selectedStatus.value) &&
            (delivery.recipient.toLowerCase().includes(filterText.toLowerCase()) ||
                delivery.country.toLowerCase().includes(filterText.toLowerCase()))
    );

    const openDeliveryDialog = (delivery) => {
        setSelectedDelivery(delivery);
        setBalancePayment(delivery.amountDue);
        setVisibleDialog(true);
    };

    const confirmDelivery = () => {
        console.log('Delivered:', selectedDelivery);
        console.log('Paid by balance:', balancePayment);
        setVisibleDialog(false);
    };

    return (
        <div className="dashboard-container">
            <h2 className="page-title">Product Delivery</h2>

            <div className="filter-panel">
                <InputText
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    placeholder="Search by recipient or country"
                    className="filter-input"
                />
                <Dropdown
                    value={selectedStatus}
                    options={deliveryStatuses}
                    onChange={(e) => setSelectedStatus(e.value)}
                    placeholder="Select Status"
                    className="status-dropdown"
                />
            </div>

            <div className="deliveries-section">
                {filteredDeliveries.map((delivery) => (
                    <Card key={delivery.id} className="delivery-card">
                        <div className="delivery-header">
                            <div>
                                <h3>{delivery.recipient}</h3>
                                <p className="delivery-country">{delivery.country}</p>
                            </div>
                            <Tag
                                value={
                                    delivery.status === 'delivered'
                                        ? 'Delivered'
                                        : delivery.status === 'ready'
                                            ? 'Ready for Pickup'
                                            : 'Pending'
                                }
                                severity={
                                    delivery.status === 'delivered'
                                        ? 'success'
                                        : delivery.status === 'ready'
                                            ? 'info'
                                            : 'warning'
                                }
                            ></Tag>
                        </div>
                        <p className="delivery-id">Order ID: {delivery.id}</p>
                        <p className="delivery-id">Amount Due: ${delivery.amountDue.toFixed(2)}</p>
                        <div className="delivery-footer">
                            <Button
                                label="Confirm Pickup"
                                icon="pi pi-check"
                                className="p-button-sm p-button-success"
                                onClick={() => openDeliveryDialog(delivery)}
                                disabled={delivery.status === 'delivered'}
                            />
                            <Button label="Resend QR Code" icon="pi pi-qrcode" className="p-button-sm p-button-secondary" />
                        </div>
                    </Card>
                ))}
            </div>

            <Dialog
                header="Confirm Delivery"
                visible={visibleDialog}
                style={{ width: '30rem' }}
                onHide={() => setVisibleDialog(false)}
                footer={
                    <div className="p-d-flex p-jc-end">
                        <Button label="Cancel" className="p-button-text" onClick={() => setVisibleDialog(false)} />
                        <Button label="Confirm" icon="pi pi-check" onClick={confirmDelivery} autoFocus />
                    </div>
                }
            >
                {selectedDelivery && (
                    <>
                        <p><strong>Recipient:</strong> {selectedDelivery.recipient}</p>
                        <p><strong>Country:</strong> {selectedDelivery.country}</p>
                        <p><strong>Order ID:</strong> {selectedDelivery.id}</p>
                        <p><strong>QR Code:</strong> {selectedDelivery.code}</p>
                        <p><strong>Amount Due:</strong> ${selectedDelivery.amountDue.toFixed(2)}</p>
                        <div className="p-field">
                            <label htmlFor="balance">Pay with balance</label>
                            <InputNumber
                                id="balance"
                                value={balancePayment}
                                onValueChange={(e) => setBalancePayment(e.value)}
                                mode="currency"
                                currency="USD"
                                locale="en-US"
                                showButtons
                            />
                        </div>
                    </>
                )}
            </Dialog>
        </div>
    );
};

export default DeliveryPage;
